export default __webpack_public_path__ + "static/media/campesino.bd3be778.png";